// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Table } from 'react-bootstrap';
import Sorter from '../../utils/Sorting/Sorter';
import { TagForm } from '../../forms/TagForm';
import '../../../styles/components/PartiesList.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../infrastructure/utils/common';
import TagsListMobile from './TagsListMobile';

export default class TagsList extends React.PureComponent {
  changeTag = event => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { changeType } = this.props;
    event.preventDefault();
    event.stopPropagation();
    const { value } = event.target;
    const tag = event.currentTarget.getAttribute('data-tag');
    changeType(tag, value);
  };

  changeSort = event => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { changeSort } = this.props;
    event.stopPropagation();
    event.preventDefault();
    changeSort(event.currentTarget.getAttribute('name'));
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { content, handleTagChange, activeSort } = this.props;

    if (isMobileResolution()) {
      return (
        <TagsListMobile content={content} handleTagChange={handleTagChange} />
      );
    }

    return (
      <Table hover>
        <thead>
          <tr>
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              <th name='name' className='sortColumn' onClick={this.changeSort}>
                Name
                <Sorter activeSort={activeSort} name='name' />
              </th>
            }
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          {content.map(tag => (
            // @ts-ignore
            // eslint-disable-next-line react/no-unknown-property
            <tr key={tag.name} tagval={tag.name} className='listrow'>
              <td style={{ width: '30%' }}>{tag.name}</td>
              <td>
                {
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  <TagForm changeType={handleTagChange} tag={tag} />
                }
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }
}
